/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponseCompany
 */
export interface GetConfig200ResponseCompany {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    taxId: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    number?: string;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseCompany
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponseCompany
     */
    longitude?: number;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    regionCode: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    provinceCode?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    neighborhood?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    iban?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    additionalInformation?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseCompany
     */
    deleted: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    payoutInterval: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponseCompany
     */
    isTaxExempt: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    taxExemptionReason?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponseCompany
     */
    name: string;
}

/**
 * Check if a given object implements the GetConfig200ResponseCompany interface.
 */
export function instanceOfGetConfig200ResponseCompany(value: object): value is GetConfig200ResponseCompany {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('taxId' in value) || value['taxId'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('regionCode' in value) || value['regionCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    if (!('payoutInterval' in value) || value['payoutInterval'] === undefined) return false;
    if (!('isTaxExempt' in value) || value['isTaxExempt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function GetConfig200ResponseCompanyFromJSON(json: any): GetConfig200ResponseCompany {
    return GetConfig200ResponseCompanyFromJSONTyped(json, false);
}

export function GetConfig200ResponseCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponseCompany {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'],
        'companyName': json['companyName'],
        'taxId': json['taxId'],
        'address': json['address'],
        'street': json['street'] == null ? undefined : json['street'],
        'number': json['number'] == null ? undefined : json['number'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'regionCode': json['regionCode'],
        'countryCode': json['countryCode'],
        'provinceCode': json['provinceCode'] == null ? undefined : json['provinceCode'],
        'neighborhood': json['neighborhood'] == null ? undefined : json['neighborhood'],
        'city': json['city'] == null ? undefined : json['city'],
        'province': json['province'] == null ? undefined : json['province'],
        'country': json['country'] == null ? undefined : json['country'],
        'email': json['email'],
        'iban': json['iban'] == null ? undefined : json['iban'],
        'additionalInformation': json['additionalInformation'] == null ? undefined : json['additionalInformation'],
        'deleted': json['deleted'],
        'payoutInterval': json['payoutInterval'],
        'isTaxExempt': json['isTaxExempt'],
        'taxExemptionReason': json['taxExemptionReason'] == null ? undefined : json['taxExemptionReason'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'name': json['name'],
    };
}

export function GetConfig200ResponseCompanyToJSON(json: any): GetConfig200ResponseCompany {
    return GetConfig200ResponseCompanyToJSONTyped(json, false);
}

export function GetConfig200ResponseCompanyToJSONTyped(value?: GetConfig200ResponseCompany | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'companyName': value['companyName'],
        'taxId': value['taxId'],
        'address': value['address'],
        'street': value['street'],
        'number': value['number'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'postalCode': value['postalCode'],
        'regionCode': value['regionCode'],
        'countryCode': value['countryCode'],
        'provinceCode': value['provinceCode'],
        'neighborhood': value['neighborhood'],
        'city': value['city'],
        'province': value['province'],
        'country': value['country'],
        'email': value['email'],
        'iban': value['iban'],
        'additionalInformation': value['additionalInformation'],
        'deleted': value['deleted'],
        'payoutInterval': value['payoutInterval'],
        'isTaxExempt': value['isTaxExempt'],
        'taxExemptionReason': value['taxExemptionReason'],
        'entityType': value['entityType'],
        'name': value['name'],
    };
}

